import type { Priority, PriorityMap } from '../../common/types';

export const transformValue = (priorities: Priority[]): PriorityMap => {
	const priorityMap = new Map();
	priorities.forEach((priority) => priorityMap.set(priority.name, priority));
	return priorityMap;
};
